import React from 'react';
import { Dialog } from 'primereact/dialog';
import { Button, ButtonProps } from 'primereact/button';

export interface ModalAction {
  label: string;
  onClick: () => void;
  buttonProps?: Omit<ButtonProps, 'label' | 'onClick'>;
}

interface ModalProps {
  visible: boolean;
  title: string;
  content?: React.ReactNode;
  actions: ModalAction[];
  onHide: () => void;
  className?: string;
  actionsClassName?: string;
  closable?: boolean;
  dismissableMask?: boolean;
  position?:
    | 'center'
    | 'top'
    | 'bottom'
    | 'left'
    | 'right'
    | 'top-left'
    | 'top-right'
    | 'bottom-left'
    | 'bottom-right';
}

const Modal: React.FC<ModalProps> = ({
  visible,
  title,
  content,
  actions,
  onHide,
  className,
  actionsClassName,
  closable = false,
  dismissableMask = true,
  position = 'center',
}) => {
  const footer =
    actions.length > 0 ? (
      <div className={actionsClassName}>
        {actions.map((action) => (
          <Button
            key={action.label}
            label={action.label}
            onClick={action.onClick}
            {...action.buttonProps}
          />
        ))}
      </div>
    ) : undefined;

  return (
    <Dialog
      header={
        <span
          style={{
            fontSize: '1rem',
            lineHeight: '1.375rem',
            fontWeight: 400,
          }}
        >
          {title}
        </span>
      }
      style={{ width: '37.5rem' }}
      contentStyle={
        content ? { padding: '1.25rem 1.875rem 1.875rem' } : { display: 'none' }
      }
      visible={visible}
      className={className}
      onHide={onHide}
      footer={footer}
      position={position}
      dismissableMask={dismissableMask}
      draggable={false}
      resizable={false}
      closable={closable}
    >
      {content ?? null}
    </Dialog>
  );
};

export default Modal;
